module.exports = __webpack_public_path__ + "static/media/coupon02_zhCht.f109ae03.png";